import parsePhoneNumberFromString from "libphonenumber-js";

export function formatPhoneNumber(raw: string) {
    const phoneNumber = parsePhoneNumberFromString(raw);
    if (!phoneNumber) return raw;
    const country = phoneNumber.country?.toUpperCase();
    if (country === 'BR') {
        const national = phoneNumber.formatNational();
        return national.replace(/^(\d{2})/, '($1)');
    }
    return phoneNumber.formatInternational();
};

export function getPhoneCountry(raw: string): string {
    const phoneNumber = parsePhoneNumberFromString(`+${raw}`)
    if (!phoneNumber)
        return 'br'

    return phoneNumber.country?.toLowerCase() || 'unknown'
}